import { getErrorMessage } from "../getErrorMessage";
import type { Validator, Range } from "./types";

// Expects answer as a comma-separated list of non-negative numbers: e.g. "40,60".
// (Upstream we flatten per-label answers and concatenate numbers.)
// Valid only if there is at least one number and the total is exactly 100.
// Optionally validates individual percentage ranges using Range.min/max.
export const percentages: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
}) => {
  let valid = true;

  const rangeConfig = validation.value as Range | undefined;
  const individualMin = Number(rangeConfig?.min) || 0;
  const individualMax = Number(rangeConfig?.max) || 100;

  if (!answer) {
    valid = false;
  } else {
    const parts = answer
      .split(",")
      .map(p => p.trim())
      .filter(Boolean)
      .map(Number);

    if (!parts.length) {
      valid = false;
    } else {
      let total = 0;
      for (const num of parts) {
        if (!Number.isFinite(num) || num < 0) {
          valid = false;
          break;
        }

        // Check individual range constraints
        if (num > 0 && (num < individualMin || num > individualMax)) {
          valid = false;
          break;
        }

        total += num;
      }

      // Check total sum only if individual validations passed
      if (valid && total !== 100) {
        valid = false;
      }
    }
  }

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
          fallbackMessage: "Percentages must total 100%",
        }),
  };
};
